import { writable } from "svelte/store";

export const downloaderOpen = writable(false);
